import { action } from 'mobx';

import type { BicData } from '../../model';

export const getBicByBankName = action(
  (bicData: BicData[] | undefined, bankName: string): string | undefined =>
    bicData?.find((item) => item.name === bankName)?.bic
);
